import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Settings from "./settings";
import Forms from "./forms";

const feature = "settings";

const InitialState = Record({
  settings: new Settings()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function SettingsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.settings
    ) {
      state = state.updateIn(["settings", "entities"], map =>
        map.mergeDeep(action.payload.entities.settings)
      );
    }
  }

  switch (action.type) {
    case actions.GET_SETTINGS: {
      return state.setIn(["settings", "loading"], true);
    }
    case actions.GET_SETTINGS_SUCCESS: {
      state = state.deleteIn(["settings", "entities"]);
      state = state.deleteIn(["settings", "results"]);
      state = state.setIn(
        ["settings", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["settings", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["settings", "entities"], map =>
        map.mergeDeep(action.payload.entities.settings)
      );
      state = state.setIn(
        ["settings", "results"],
        action.payload.result.settings
      );
      return state.setIn(["settings", "loading"], false);
    }
    case actions.GET_SETTINGS_ERROR: {
      return state.setIn(["settings", "loading"], false);
    }

    case actions.GET_SETTING: {
      return state.setIn(["settings", "loading"], true);
    }
    case actions.GET_SETTING_SUCCESS: {
      return state.setIn(["settings", "loading"], false);
    }
    case actions.GET_SETTING_ERROR: {
      return state.setIn(["settings", "loading"], false);
    }

    case actions.POST_SETTINGS: {
      return disableForm(state, "createSetting");
    }
    case actions.POST_SETTINGS_SUCCESS: {
      state = clearForm(state, "createSetting", Forms);
      return enableForm(state, "createSetting");
    }
    case actions.POST_SETTINGS_ERROR: {
      state = enableForm(state, "createSetting");
      return setFormErrors(state, "createSetting", action.payload.errors);
    }

    case actions.DELETE_SETTING: {
      return state.deleteIn(["settings", "entities", action.payload.uid]);
    }
  }

  return entitiesReducer(formsReducer(state, feature, action), feature, action);
}



// WEBPACK FOOTER //
// ./src/common/settingsApi/reducer.js